// mobile <48em -- laptop 48~85.3125emem -- big-desktop >85.3125em
export const breakpoints = {
  sm: '68.75em', // 1099px
  md: '108em', // 1728px
  lg: '160em', // 2560px
}
